<template>
  <div>
    <h2>Affiliates News History {{ this.id }}</h2>
    <button @click="goBack">
      <i class="fas fa-undo"></i>
      Back
    </button>
    <table>
      <thead>
      <tr class="header_history">
        <th class="text-center" v-for="header in tableHistoryHeaders">
          {{ header.name }}
        </th>
      </tr>
      </thead>
      <tbody>
      <tr style="border-bottom: 2px solid #cccccc !important"
          v-for="item in alertsHistory" :key="item.id">
        <td>{{ item.user }}</td>
        <td>{{ item.dateAdded }}</td>
        <td>{{ item.action }}</td>
        <td>
          <p v-for="(log, index) in item.logs" :key="index" class="mb-0 log">
            <span v-if="log.newValue">{{log.field}}:{{ log.oldValue }} &#8594; </span>
            <span>{{ log.newValue || '' }}</span>
          </p>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

import affiliateNewsApi from "@/api/affiliateNews";

export default {
  name: 'AffiliatesAlertsHistory',
  data() {
    return {
      id: null,
      alertsHistory: [],
      tableHistoryHeaders: [
        { name: 'User' },
        { name: 'Date/Time' },
        { name: 'Action' },
        { name: 'Changes' },
      ],
    };
  },
  mounted() {
    this.id = this.$route.params.id;
    this.fetchNewsHistory(this.id);
  },
  methods: {
    goBack() {
      this.$router.push(`/affiliates/news/`);
    },
    async fetchNewsHistory(id) {
      try {
        const res = await affiliateNewsApi.getAffiliateNewsHistoryById(id);
        this.alertsHistory = res.map(item => ({
          ...item,
          logs: JSON.parse(item.logs)
        }));
        console.log(this.alertsHistory);
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>

<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
}

th, td {
  padding: 8px;
  text-align: center !important;
  border-bottom: 1px solid #ccc;
}

.log {
  text-align: left !important;
  padding-left: 35% !important;
}

th {
  background-color: #fcfcfc;
}
</style>
